var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-layout"},[_c('navbar-dashboard'),_c('sidebar-dashboard'),_c('div',{staticClass:"dashboard-content-page"},[_c('transition',{attrs:{"name":"router-anim","enter-active-class":`animated fadeInUp`,"mode":"out-in","leave-active-class":`animated fadeOut`}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }